import { useStore } from 'react-redux';

const useContentGatewayClient = () => {
  const store = useStore();
  return store?.sagaTask?.context?.contentGatewayApiClient;
};

export default useContentGatewayClient;
